import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ManualPriceInterceptor } from './manual-price.interceptor';

@NgModule({
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useExisting: ManualPriceInterceptor,
      multi: true,
    },
  ],
})
export class InterceptorsModule {}
